import { render, staticRenderFns } from "./ChapterAdmin.vue?vue&type=template&id=4dc809e6&"
import script from "./ChapterAdmin.vue?vue&type=script&lang=ts&"
export * from "./ChapterAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4dc809e6', component.options)
    } else {
      api.reload('4dc809e6', component.options)
    }
    module.hot.accept("./ChapterAdmin.vue?vue&type=template&id=4dc809e6&", function () {
      api.rerender('4dc809e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/courses/CoursePage/components/ChapterAdmin.vue"
export default component.exports